module.exports = __webpack_public_path__ + "img/sec1111.75a25f3a.jpg";